import(/* webpackMode: "eager" */ "/app/src/app/(pages)/page.tsx")